module.exports = __webpack_public_path__ + "static/icon-3-yellow-973812158d1ba2799e5ddcfc6db1a190.png";